
{
  "fr": {
    "configuratorGlassSettingsColorsSizesRow": {
      "label": "Taille\u00a0:",
      "hypeProduct": "Top\u00a0des ventes",
      "error": {
        "sizeNotAvailable": "Le thème sélectionné n'existe pas dans la taille demandée.\n\nCliquez sur OK pour afficher les autres thèmes disponibles."
      }
    }
  }
}
